// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const modelosFullfilledReducer = makeSetReducer(['modelos/fullfilled']);
